import React, { Component } from 'react';
import { Modal, Button, PanelGroup, Panel } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import CRMInstanceName from '../../../../components/crm-instance-name';

class EnableApiInstruction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      activeKey: '1',
    };
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  close() {
    this.setState({ isOpen: false });
  }

  open() {
    this.setState({ isOpen: true });
  }

  handleSelect(activeKey) {
    this.setState({ activeKey });
  }

  renderModal() {
    const { isOpen, activeKey } = this.state;
    return (
      <Modal bsSize="lg" show={isOpen} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>Enable Resful API</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="well well-sm">
              Your <CRMInstanceName /> Administrator will need to enable API access in <CRMInstanceName /> for all Users to enable you to connect TruVoice Automation to your <CRMInstanceName /> account.
              <br />
              Note: Your <CRMInstanceName /> administrator controls your Profile and Permission Sets.
            </div>

            <PanelGroup activeKey={activeKey} onSelect={this.handleSelect} accordion>
              <Panel
                header={
                  <div style={{ cursor: 'pointer' }}>
                    <Fa name={activeKey === '1' ? 'minus-square-o' : 'plus-square-o'} /> How to enable API access in <CRMInstanceName /> by Profile
                  </div>
                }
                eventKey="1"
              >
                <ol>
                  <li>
                    <div>Click <strong>Setup</strong> in <CRMInstanceName /></div>
                  </li>
                  <li>
                    <div>Click <strong>Manage Users</strong> &raquo; <strong>Profiles</strong>.</div>
                    <img src="/public/instructions/enable-api/1-2.png" role="presentation" width="200" />
                  </li>
                  <li>
                    <div>Click <strong>Edit</strong> against the specific Profile.</div>
                    <img src="/public/instructions/enable-api/1-3.png" role="presentation" />
                  </li>
                  <li>
                    <div>Scroll down to Administrative Permissions and check the <strong>API Enabled</strong> box.</div>
                    <img src="/public/instructions/enable-api/1-4.png" role="presentation" style={{ width: '100%' }} />
                  </li>
                  <li>
                    <div>Click <strong>Save</strong>.</div>
                  </li>
                </ol>
              </Panel>
              <Panel
                header={
                  <div style={{ cursor: 'pointer' }}>
                    <Fa name={activeKey === '2' ? 'minus-square-o' : 'plus-square-o'} /> How to enable API Access in <CRMInstanceName /> by Permission Set
                  </div>
                }
                eventKey="2"
              >
                <ol>
                  <li>
                    <div>Click <strong>Setup</strong> in <CRMInstanceName /></div>
                  </li>
                  <li>
                    <div>Click <strong>Manage Users</strong> &raquo; <strong>Permission Sets</strong>.</div>
                    <img src="/public/instructions/enable-api/2-2.png" role="presentation" width="200" />
                  </li>
                  <li>
                    <div>Select the specific <strong>Permission Set</strong>.</div>
                    <img src="/public/instructions/enable-api/2-3.png" role="presentation" style={{ width: '100%' }} />
                  </li>
                  <li>
                    <div>Click <strong>System</strong> &raquo; <strong>System Permissions</strong> &raquo; <strong>Edit</strong></div>
                  </li>
                  <li>
                    <div>Check the <strong>API Enabled</strong> box.</div>
                    <img src="/public/instructions/enable-api/2-5.png" role="presentation" style={{ width: '100%' }} />
                  </li>
                  <li>
                    <div>Click <strong>Save</strong>.</div>
                  </li>
                </ol>
              </Panel>
            </PanelGroup>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="link" onClick={this.close}>OK</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    return (
      <div>
        <div className="text-danger">
          <small>
            <Fa name="exclamation-triangle" /> Restful API Access is currently disabled for your account.&nbsp;
            Please follow&nbsp;
            <a href="" onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.open(); }}>
              these instructions
            </a> to enable it.
          </small>
        </div>
        {this.renderModal()}
      </div>
    );
  }
}

EnableApiInstruction.propTypes = {
};
export default EnableApiInstruction;
